import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import spabootApi from '@/spaboot-api'

Vue.use(Vuex)

export default {
    state: {
        token: null,
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        }
    },
    actions: {
        async login({dispatch}, credentials) {
            let response = await spabootApi.post('/login', credentials)
            if (response.status === 200) {
                localStorage.setItem('token', response.data)
                return await dispatch('autoLogin')
            } else {
                dispatch('logout')
                throw new Error("Die Anmeldung ist fehlgeschlagen. Bitte versuche es erneut!")
            }
        },
        logout({commit}){
            commit('setToken', null)
            localStorage.removeItem('token')
            router.push('/')
        },
        async autoLogin({commit}) {
            let token = localStorage.getItem('token')
            if (token) {
                spabootApi.setAuthtoken(token)
                commit('setToken', token)
            }
        }
    },
    getters: {
        loggedIn(state) {
            return state.token !== null
        }
    }
}

